import React, { Component } from 'react';
import Link from 'gatsby-link';
import ArrowRightBlack from '../../assets/global-logos/arrow/arrow-right-black.svg';
import ArrowRightWhite from '../../assets/global-logos/arrow/arrow-right-white.svg';
import { css } from 'emotion';
import styles from './button-arrow.module.css';

class ButtonArrow extends Component {
  constructor() {
    super();
    this.state = {
      hover: false,
    };
  }

  onHover = () => {
    this.setState({
      hover: true,
    });
  };
  offHover = () => {
    this.setState({
      hover: false,
    });
  };

  render() {
    const { message, url, external } = this.props;
    const { hover } = this.state;

    return (
      <React.Fragment>
        <div
          className={styles.btn}
          onMouseEnter={this.onHover}
          onMouseLeave={this.offHover}
        >
          {external === true ? (
            <a href={`${url}`} target="_blank" className={styles.btnText}>
              <div
                className={[styles.btnBG, styles.btnTransparent].join(' ')}
              />
              <span className={styles.explore}>{message}</span>
              <span className={styles.exploreArrow}>
                {hover === true ? <ArrowRightWhite /> : <ArrowRightBlack />}
              </span>
            </a>
          ) : (
            <Link to={`/${url}`} className={styles.btnText}>
              <div className={styles.btnBG} />
              <span className={styles.explore}>{message}</span>
              <span className={styles.exploreArrow}>
                {hover === true ? <ArrowRightWhite /> : <ArrowRightBlack />}
              </span>
            </Link>
          )}
        </div>
      </React.Fragment>
    );
  }
}

export default ButtonArrow;



// WEBPACK FOOTER //
// ./src/components/button-arrow/index.js